
exports.AddToCart = async (item_id, item_number, item_title, item_mrp, item_price, item_qty, item_img_url, item_url, max_qty, item_sup_id = 0, apiB2BURL, token) => {

    // call api to add to cart /Orders/AddToCart with auth token in header
    // if success, add to local storage
    // if fail, return false
    // return true if added to cart successfully
    // return false if fail to add to cart
    // item_id, item_number, item_title, item_mrp, item_price, item_qty, item_img_url, item_url, max_qty

    var post_fields = {
        item_id,
        item_number,
        item_title,
        item_mrp: item_mrp ?? 0,
        item_price,
        item_qty,
        item_img_url,
        item_url,
        max_qty,
        item_sup_id
    };

    const business_id = localStorage.getItem("business_id");
    const business_user_id = localStorage.getItem("business_user_id");



    var response = await fetch(`${apiB2BURL}/Customer/Orders/AddToCart`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'token': token,
            'businessid': business_id,
            'businessuserid': business_user_id
        },
        body: JSON.stringify(post_fields)
    });

    if (response.ok) {
        var carts = localStorage.getItem('carts') ? JSON.parse(localStorage.getItem('carts')) : [];

        if (carts !== "" && carts !== undefined && carts !== null) {
            // carts = JSON.parse(carts);
            const index = carts.findIndex(item => item.item_number === item_number);
            if (index !== -1) {
                var remaining = Number(carts[index].max_qty) - carts[index].item_qty;
                if (item_qty > remaining) {
                    carts[index].item_qty = carts[index].max_qty;
                } else {
                    carts[index].item_qty = carts[index].item_qty + item_qty;
                }

                localStorage.setItem('carts', JSON.stringify(carts));
                return true;
            } else {
                carts.push({
                    item_id: item_id,
                    item_number: item_number,
                    item_title: item_title,
                    item_mrp: item_mrp,
                    item_price: item_price,
                    item_qty: item_qty,
                    item_img_url: item_img_url,
                    item_url: item_url,
                    max_qty: max_qty,
                    item_sup_id: item_sup_id || 0
                });
                localStorage.setItem('carts', JSON.stringify(carts));
                return true;
            }
        } else {
            carts.push({
                item_id: item_id,
                item_number: item_number,
                item_title: item_title,
                item_mrp: item_mrp,
                item_price: item_price,
                item_qty: item_qty,
                item_img_url: item_img_url,
                item_url: item_url,
                max_qty: max_qty,
                item_sup_id: item_sup_id || 0
            });
            localStorage.setItem('carts', JSON.stringify(carts));
            return true;
        }
    } else {
        return false;
    }
}

exports.GetCartItemQty = async (item_number) => {
    var carts = localStorage.getItem('carts') ? JSON.parse(localStorage.getItem('carts')) : [];

    if (carts !== "" && carts !== undefined && carts !== null) {
        const index = carts.findIndex(item => item.item_number === item_number);
        if (index !== -1) {
            return Number(carts[index].item_qty);
        } else {
            return 0;
        }
    } else {
        return 0;
    }
}
exports.DeleteCartItem = (index) => {

    var carts = localStorage.getItem('carts');
    carts = JSON.parse(carts);
    carts.splice(index, 1);
    localStorage.setItem('carts', JSON.stringify(carts));

    return true;
}

exports.QtyUpdate = (index, qty) => {
    var carts = localStorage.getItem('carts');
    carts = JSON.parse(carts);

    carts[index].item_qty = qty;
    localStorage.setItem('carts', JSON.stringify(carts));
    return true;
}

exports.GetCarts = () => {
    var carts = localStorage.getItem('carts');

    if (carts === "" || carts === null) {
        return [];
    }

    carts = carts !== "" ? JSON.parse(carts) : [];
    return carts;
}

exports.ClearCart = () => {
    localStorage.setItem('carts', '');
    localStorage.setItem("coupon", "");
}